// i18next-extract-mark-ns-start Services
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { TFunction } from '../../../types/t-types';
import routesMap from '../../../Routes';
import withNavigation from '../../../hoc/withNavigation';
import { navigate } from '../../../services/navigation';
import {
  LittleTitle, mobileThresholdPixels, frames, margins, tabletThresholdPixels,
} from '../v4/styledComponents';
import coutureIcon from '../../../assets/ourServices/couture.icon.services.svg';
import cordoIcon from '../../../assets/ourServices/cordo.icon.services.svg';
import maroIcon from '../../../assets/ourServices/maro.icon.services.svg';
import broderieIcon from '../../../assets/ourServices/couturier/broderies.svg';

const Container = styled.div<{ marginTop: boolean }>`
  margin: ${({ marginTop }) => (marginTop ? '120px' : '0px')} 0 ${margins.m15};
  max-width: 1180px;
  width: 100%;
  text-align: center;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 0 ${frames.tablet} ${margins.m14};
  }
  @media (max-width: ${mobileThresholdPixels}) {
    margin: 0 ${frames.mobile};
    width: calc(100% - ${frames.mobile} * 2);
    text-align: start;
  }
`;

const Services = styled.p`
  font-size: 28px;
  font-weight: 700;
  margin: 0;
`;

const BlockContainer = styled.div`
  margin-top: ${margins.m6};
  display: flex;
  justify-content: space-around;
  @media (max-width: ${mobileThresholdPixels}) {
    margin-top: ${margins.m3};
    flex-direction: column;
    gap: 24px;
  }
`;

const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    transform: scale(1.1);
  }
`;

const Icon = styled.img`
  height: 45px;
`;

const getAllServices = (t: TFunction) => [
  {
    icon: coutureIcon,
    title: t('Couturier'),
    url: routesMap.CoutureServicesPage.url,
  },
  {
    icon: maroIcon,
    title: t('Maroquinier'),
    url: routesMap.LeatherGoodsServicesPage.url,
  },
  {
    icon: cordoIcon,
    title: t('Cordonnier'),
    url: routesMap.ShoesServicesPage.url,
  },
  {
    icon: broderieIcon,
    title: t('Broderie'),
    url: routesMap.EmbroideryServicesPage.url,
  },
];

function AllServices({ noTitle, marginTop }: { noTitle: boolean, marginTop: boolean }) {
  const { t } = useTranslation();
  return (
    <Container marginTop={marginTop}>
      {!noTitle && <LittleTitle>{t('Tous nos services')}</LittleTitle>}
      <BlockContainer>
        {getAllServices(t).map((service) => (
          <Block onClick={() => navigate(service.url)} key={service.title}>
            <Icon src={service.icon} alt={service.title} />
            <Services>{service.title}</Services>
          </Block>
        ))}
      </BlockContainer>
    </Container>
  );
}

export default withNavigation(AllServices);
